import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
import './index.css';

Sentry.init({
  dsn: "https://ed4dca4011c281684b67c103d704a02b@o4510997942697984.ingest.us.sentry.io/4510997944008704",
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  tracesSampleRate: 0.3,
  sendDefaultPii: true,
});

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);